import { TextLink } from "nystem-components";

const SliderLink = (props) => <TextLink {...props} />;
export default SliderLink;
